import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    client: {},
    cameras: [],
    sharedCameras: [],
    intercoms: [],
    operatorParameters: {},
  },
  actions,
  mutations,
};
